import { render, staticRenderFns } from "./submitOrder.vue?vue&type=template&id=16d536a8&scoped=true"
import script from "./submitOrder.vue?vue&type=script&lang=js"
export * from "./submitOrder.vue?vue&type=script&lang=js"
import style0 from "./submitOrder.vue?vue&type=style&index=0&id=16d536a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d536a8",
  null
  
)

export default component.exports